import { Sprite } from "./Sprite";
import { Widget } from "../components/Widget";
import { Event } from "../events/Event";
import { Resource } from "../resource/Resource";
import { Handler } from "../utils/Handler";
import { ILaya } from "../../ILaya";
import { Scene2DSpecialManager } from "./Scene2DSpecial/Scene2DSpecialManager";
import { TransformKind } from "./SpriteConst";
import { ShaderDataType } from "../RenderDriver/DriverDesign/RenderDevice/ShaderData";
import { LayaGL } from "../layagl/LayaGL";
import { Camera2D } from "./Scene2DSpecial/Camera2D";
import { BlendModeHandler } from "../webgl/canvas/BlendMode";
export class Scene extends Sprite {
    static regManager(type, cla) {
        Scene.componentManagerMap.set(type, cla);
    }
    static __init__() {
        Camera2D.shaderValueInit();
        let scene2DUniformMap = Scene.scene2DUniformMap = LayaGL.renderDeviceFactory.createGlobalUniformMap("Sprite2DGlobal");
        scene2DUniformMap.addShaderUniform(Camera2D.VIEW2D, "u_view2D", ShaderDataType.Matrix3x3);
    }
    constructor() {
        super();
        this.autoDestroyAtClosed = false;
        this._componentElementDatasMap = {};
        this._specialManager = new Scene2DSpecialManager();
        this._timer = ILaya.timer;
        this._widget = Widget.EMPTY;
        this._area2Ds = new Set();
        this._scene = this;
        Scene.componentManagerMap.forEach((val, key) => {
            this._specialManager.componentElementMap.set(key, new val(this));
        });
        this._globalRenderData = LayaGL.render2DRenderPassFactory.create2DGlobalRenderDataHandle();
        this._globalRenderData.globalShaderData = this._shaderData = this._specialManager._shaderData;
        this._globalRenderData.renderLayerMask = -1;
        this._struct.globalRenderData = this._globalRenderData;
        this._struct.spriteShaderData = this._shaderData;
        BlendModeHandler.initBlendMode(this._shaderData);
    }
    get componentElementDatasMap() {
        return this._componentElementDatasMap;
    }
    set componentElementDatasMap(value) {
        this._componentElementDatasMap = value;
        this._specialManager.componentElementMap.forEach((value, key) => {
            this._componentElementDatasMap[key] && value.Init(this._componentElementDatasMap[key]);
        });
    }
    _update() {
        var delta = ILaya.timer.delta * 0.001;
        this._specialManager.componentElementMap.forEach((value) => {
            value.update(delta);
        });
    }
    getComponentElementManager(type) {
        return this._specialManager.componentElementMap.get(type);
    }
    getNodeByID(id) {
        if (this._idMap)
            return this._idMap[id];
        return null;
    }
    open(closeOther, param) {
        if (closeOther == null || closeOther)
            Scene.closeAll();
        Scene.root.addChild(this);
        if (this._scene3D)
            ILaya.stage.addChildAt(this._scene3D, 0);
        this.onOpened(param);
    }
    onOpened(param) {
    }
    close(type = null) {
        this.onClosed(type);
        if (this.autoDestroyAtClosed) {
            this.destroy();
            if (this._scene3D)
                this._scene3D.destroy();
        }
        else {
            this.removeSelf();
            if (this._scene3D)
                this._scene3D.removeSelf();
        }
    }
    onClosed(type) {
    }
    destroy(destroyChild = true) {
        super.destroy(destroyChild);
        if (this._scene3D) {
            this._scene3D.destroy();
            this._scene3D = null;
        }
        this._idMap = null;
        Scene.unDestroyedScenes.delete(this);
        this._specialManager.componentElementMap.forEach(element => {
            element.destroy();
        });
    }
    get timer() {
        return this._timer;
    }
    set timer(value) {
        this._timer = value;
    }
    get scene3D() {
        return this._scene3D;
    }
    get top() {
        return this._widget.top;
    }
    set top(value) {
        if (value != this._widget.top) {
            this._getWidget().top = value;
        }
    }
    get bottom() {
        return this._widget.bottom;
    }
    set bottom(value) {
        if (value != this._widget.bottom) {
            this._getWidget().bottom = value;
        }
    }
    get left() {
        return this._widget.left;
    }
    set left(value) {
        if (value != this._widget.left) {
            this._getWidget().left = value;
        }
    }
    get right() {
        return this._widget.right;
    }
    set right(value) {
        if (value != this._widget.right) {
            this._getWidget().right = value;
        }
    }
    get centerX() {
        return this._widget.centerX;
    }
    set centerX(value) {
        if (value != this._widget.centerX) {
            this._getWidget().centerX = value;
        }
    }
    get centerY() {
        return this._widget.centerY;
    }
    set centerY(value) {
        if (value != this._widget.centerY) {
            this._getWidget().centerY = value;
        }
    }
    render(x, y) {
        this._preRenderUpdate(x, y);
        for (let area of this._area2Ds) {
            area.render();
        }
    }
    setglobalRenderData(uniformIndex, type, value) {
        this._shaderData && this._shaderData.setShaderData(uniformIndex, type, value);
        for (let area2D of this._area2Ds) {
            area2D._globalShaderData.setShaderData(uniformIndex, type, value);
        }
    }
    _preRenderUpdate(x, y) {
        this._specialManager._shaderData;
        if (this._light2DManager)
            this._light2DManager.preRenderUpdate();
    }
    _transChanged(kind) {
        super._transChanged(kind);
        if ((kind & TransformKind.Layout) != 0)
            this.callLater(this._sizeChanged);
    }
    _sizeChanged() {
        this.event(Event.RESIZE);
        if (this._widget !== Widget.EMPTY)
            this._widget.resetLayout();
    }
    _onAdded() {
        super._onAdded();
        ILaya.stage._scene2Ds.push(this);
    }
    _onRemoved() {
        super._onRemoved();
        let index = ILaya.stage._scene2Ds.indexOf(this);
        ILaya.stage._scene2Ds.splice(index, 1);
    }
    freshLayout() {
        this.refreshLayout();
    }
    refreshLayout() {
        if (this._widget != Widget.EMPTY) {
            this._widget.resetLayout();
        }
    }
    _getWidget() {
        this._widget === Widget.EMPTY && (this._widget = this.addComponent(Widget));
        return this._widget;
    }
    static get root() {
        let root = Scene._root;
        if (!root) {
            root = Scene._root = ILaya.stage.addChild(new Sprite());
            root.name = "root";
            root.mouseThrough = true;
            ILaya.stage.on("resize", null, () => {
                root.size(ILaya.stage.width, ILaya.stage.height);
                root.event(Event.RESIZE);
            });
            root.size(ILaya.stage.width, ILaya.stage.height);
            root.event(Event.RESIZE);
        }
        return root;
    }
    static load(url, complete, progress) {
        return Scene._load(url, progress ? value => progress.runWith(value) : null).then(scene => {
            if (complete)
                complete.runWith(scene);
            return scene;
        });
    }
    static open(url, closeOther, param, complete, progress) {
        if (typeof (complete) === "function") {
            progress = complete;
            complete = null;
        }
        if (typeof (param) === "function") {
            complete = param;
            param = null;
        }
        if (progress instanceof Handler) {
            let h = progress;
            progress = (value) => h.runWith(value);
        }
        return Scene._load(url, progress).then(scene => {
            scene.open(closeOther, param);
            if (complete instanceof Handler)
                complete.runWith(scene);
            else if (complete)
                complete(scene);
            return scene;
        });
    }
    static _load(url, progress) {
        Scene.showLoadingPage();
        return ILaya.loader.load(url, null, value => {
            if (Scene._loadPage)
                Scene._loadPage.event("progress", value);
            if (progress)
                progress(value);
        }).then((content) => {
            Scene.hideLoadingPage();
            if (!content)
                throw new Error("Can not find scene:" + url);
            let scene;
            let errors = [];
            let ret = content.create(null, errors);
            if (errors.length > 0)
                console.warn(`Error loading ${url}: \n${errors.join("\n")}`);
            if (ret instanceof Scene)
                scene = ret;
            else if (ret._nodeType === 1) {
                scene = new Scene();
                scene.left = scene.right = scene.top = scene.bottom = 0;
                scene._scene3D = ret;
            }
            else
                throw new Error("Not a scene:" + url);
            if (scene._scene3D)
                scene._scene3D._scene2D = scene;
            Scene.unDestroyedScenes.add(scene);
            return scene;
        });
    }
    static close(url, name) {
        let flag = false;
        for (let scene of Scene.unDestroyedScenes) {
            if (scene && scene.parent && scene.url === url && (name == null || scene.name == name)) {
                scene.close();
                flag = true;
                break;
            }
        }
        return flag;
    }
    static closeAll() {
        let root = Scene.root;
        for (let i = 0, n = root.numChildren; i < n; i++) {
            var scene = root.getChildAt(0);
            if (scene instanceof Scene)
                scene.close();
            else
                scene.removeSelf();
        }
    }
    static destroy(url, name) {
        let flag = false;
        for (let scene of Scene.unDestroyedScenes) {
            if (scene.url === url && (name == null || scene.name == name) && !scene._destroyed) {
                scene.destroy();
                flag = true;
                break;
            }
        }
        return flag;
    }
    static gc() {
        Resource.destroyUnusedResources();
    }
    static setLoadingPage(loadPage) {
        Scene._loadPage = loadPage;
    }
    static showLoadingPage(param = null, delay = 500) {
        if (Scene._loadPage) {
            ILaya.systemTimer.clear(null, Scene._showLoading);
            ILaya.systemTimer.clear(null, Scene._hideLoading);
            ILaya.systemTimer.once(delay, null, Scene._showLoading, [param], false);
        }
    }
    static _showLoading(param) {
        ILaya.stage.addChild(Scene._loadPage);
        if (Scene._loadPage instanceof Scene)
            Scene._loadPage.onOpened(param);
    }
    static _hideLoading() {
        if (Scene._loadPage instanceof Scene)
            Scene._loadPage.close();
        else
            Scene._loadPage.removeSelf();
    }
    static hideLoadingPage(delay = 500) {
        if (Scene._loadPage) {
            ILaya.systemTimer.clear(null, Scene._showLoading);
            ILaya.systemTimer.clear(null, Scene._hideLoading);
            ILaya.systemTimer.once(delay, null, Scene._hideLoading);
        }
    }
}
Scene.unDestroyedScenes = new Set();
Scene.componentManagerMap = new Map();
